import { Outlet } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

import { ToastContainer } from "react-toastify";
import { ScrollRestoration } from "react-router-dom";

const RootLayout = () => {
  return (
    <>
      <ScrollRestoration />
      <div className="store-layout">
        <Header />

        <main className="store-layout__main">
          <Outlet />
        </main>

        <Footer />
      </div>
      <ToastContainer
        position={"bottom-center"}
        autoClose={false}
        hideProgressBar={true}
        limit={1}
        theme={"dark"}
      />
    </>
  )
}

export default RootLayout
